import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const KPICard = ({ icon: Icon, label, value, trend, trendUp, color = '#3B82F6', onClick }) => {
  const { dark } = useTheme();
  return (
    <div onClick={onClick} style={{
      background: dark ? '#1E293B' : '#fff', borderRadius: 14, padding: '18px 20px',
      border: `1px solid ${dark ? '#334155' : '#E2E8F0'}`,
      cursor: onClick ? 'pointer' : 'default',
      transition: 'all 0.2s',
      boxShadow: dark ? 'none' : '0 1px 3px rgba(0,0,0,0.05)',
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg, ${color}, ${color}60)` }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontSize: 12, color: dark ? '#94A3B8' : '#64748B', marginBottom: 6, fontWeight: 500 }}>{label}</div>
          <div style={{ fontSize: 26, fontWeight: 700, color: dark ? '#F1F5F9' : '#0F172A', letterSpacing: '-0.02em' }}>
            {typeof value === 'number' ? value.toLocaleString() : value}
          </div>
          {trend !== undefined && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 6, fontSize: 12, fontWeight: 600, color: trendUp ? '#10B981' : '#EF4444' }}>
              {trendUp ? <ArrowUpRight size={14} /> : <ArrowDownRight size={14} />}
              {trend}
            </div>
          )}
        </div>
        {Icon && (
          <div style={{ padding: 10, borderRadius: 10, background: color + '12' }}>
            <Icon size={22} color={color} />
          </div>
        )}
      </div>
    </div>
  );
};

export default KPICard;
